import { MLPortalSettingsService } from 'gw-capability-quoteandbind';

const storageDomain = window.location.hostname;
const QB = 'QB';
const AMP = 'AMP';
const GPA = 'GPA';
let AMPChatType = '';
let GPAChatType = '';
let QNBChatType = '';
let scriptURL = null;
let sfURL = null;
let laURL = null;
let orgId = null;

let data = false;

const prepopulatedPrechatFieldsAMP = {
    'FirstName': '',
    'LastName': '',
    'Contact_Name__c': '',
    'Contact_Type__c': 'Customer',
    'W2C_Policy_Number__c': '',
    'FWS_Customer_Type__c': 'Customer'
};

const prepopulatedPrechatFieldsGPA = {
    'FirstName': '',
    'LastName': '',
    'Contact_Name__c': '',
    'Brand__c': 'Farmers Workplace Solutions',
    'Contact_Type__c': 'Agent',
    'FWS_Customer_Type__c': 'Agent',
    'FWS_Agent_Type__c': '',
    'Agent_Code__c': ''
};

const prepopulatedPrechatFieldsQNB = {
    'FirstName': '',
    'LastName': '',
    'Contact_Name__c': '',
    'Brand__c': 'Farmers Workplace Solutions',
    'Contact_Type__c': 'Customer',
    'FWS_Chat_Request_Origin__c': 'Consumer',
    'QueryType__c': '',
    'QuerySubType__c': '',
    'Inquiry_Type__c': ''
};

const extraPrechatFormDetailsAMP = [
    {
        'label': 'Source',
        'value': 'Chat',
        'displayToAgent': true
    }, {
        'label': 'Brand',
        'value': 'Farmers Workplace Solutions',
        'displayToAgent': true
    }, {
        'label': 'Additional Info',
        'transcriptFields': ['Chat_Question__c']
    }
];

const extraPrechatFormDetailsGPA = [
    {
        'label': 'Source',
        'value': 'Chat',
        'displayToAgent': true
    }, {
        'label': 'Brand',
        'value': 'Farmers Workplace Solutions',
        'displayToAgent': true
    }, {
        'label': 'Additional Info',
        'transcriptFields': ['Chat_Question__c']
    }
];

const extraPrechatFormDetailsQNB = [
    {
        'label': 'Source',
        'value': 'Chat',
        'displayToAgent': true
    }, {
        'label': 'Brand',
        'value': 'Farmers Workplace Solutions',
        'displayToAgent': true
    }, {
        'label': 'Additional Info',
        'transcriptFields': ['Chat_Question__c']
    }
];

const extraPrechatInfoAMP = [
    {
        'entityFieldMaps': [
            {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'LastName',
                'isExactMatch': false,
                'label': 'Last Name'
            }, {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'FirstName',
                'isExactMatch': false,
                'label': 'First Name'
            }
        ],
        'entityName': 'Contact'
    },
    {
        'entityFieldMaps': [
            {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Origin',
                'isExactMatch': false,
                'label': 'Source',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Name__c',
                'isExactMatch': false,
                'label': 'ContactName',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Type__c',
                'isExactMatch': false,
                'label': 'Contact Type',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Description',
                'isExactMatch': false,
                'label': 'Additional Info',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Brand__c',
                'isExactMatch': false,
                'label': 'Brand',
            }
        ],
        'entityName': 'Case',
        'showOnCreate': true,
        'saveToTranscript': 'CaseId',
    }
];

const extraPrechatInfoGPA = [
    {
        'entityFieldMaps': [
            {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'LastName',
                'isExactMatch': false,
                'label': 'Last Name'
            }, {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'FirstName',
                'isExactMatch': false,
                'label': 'First Name'
            }
        ],
        'entityName': 'Contact'
    },
    {
        'entityFieldMaps': [
            {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Origin',
                'isExactMatch': false,
                'label': 'Source',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Description',
                'isExactMatch': false,
                'label': 'Additional Info',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Name__c',
                'isExactMatch': false,
                'label': 'ContactName',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Type__c',
                'isExactMatch': false,
                'label': 'Contact Type',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Brand__c',
                'isExactMatch': false,
                'label': 'Brand',
            }
        ],
        'entityName': 'Case',
        'showOnCreate': true,
        'saveToTranscript': 'CaseId',
    }
];

const extraPrechatInfoQNB = [
    {
        'entityFieldMaps': [
            {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'LastName',
                'isExactMatch': false,
                'label': 'Last Name'
            }, {
                'doCreate': false,
                'doFind': false,
                'fieldName': 'FirstName',
                'isExactMatch': false,
                'label': 'First Name'
            }
        ],
        'entityName': 'Contact'
    },
    {
        'entityFieldMaps': [
            {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Origin',
                'isExactMatch': false,
                'label': 'Source',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Name__c',
                'isExactMatch': false,
                'label': 'ContactName',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Contact_Type__c',
                'isExactMatch': false,
                'label': 'Contact Type',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Description',
                'isExactMatch': false,
                'label': 'Additional Info',
            }, {
                'doCreate': true,
                'doFind': false,
                'fieldName': 'Brand__c',
                'isExactMatch': false,
                'label': 'Brand',
            }
        ],
        'entityName': 'Case',
        'showOnCreate': true,
        'saveToTranscript': 'CaseId',
    }
];

const deploymentInfoAMP = {
    baseLiveAgentContentURL: '',
    deploymentId: '',
    buttonId: '',
    baseLiveAgentURL: '',
    eswLiveAgentDevName: '',
    isOfflineSupportEnabled: false
};

const deploymentInfoGPA = {
    baseLiveAgentContentURL: '',
    deploymentId: '',
    buttonId: '',
    baseLiveAgentURL: '',
    eswLiveAgentDevName: '',
    isOfflineSupportEnabled: false
};

const deploymentInfoQNB = {
    baseLiveAgentContentURL: '',
    deploymentId: '',
    buttonId: '',
    baseLiveAgentURL: '',
    eswLiveAgentDevName: '',
    isOfflineSupportEnabled: false
};


const initChatSettings = (deploymentInfo, chatSettings) => {
    deploymentInfo.baseLiveAgentContentURL = chatSettings.laContentUrl;
    deploymentInfo.deploymentId = chatSettings.deploymentId;
    deploymentInfo.buttonId = chatSettings.buttonId;
    deploymentInfo.baseLiveAgentURL = chatSettings.baseLaUrl;
    deploymentInfo.eswLiveAgentDevName = chatSettings.laDevName;
};

export default {
    // Callback functions are used to ensure this object is initialized before it is used.
    init: (callback, p, cb, auth) =>{
        const settings = MLPortalSettingsService.getSettings(auth);
        settings.then((response)=> {
            if (response) {
                scriptURL = response.clickToChatSettings.scriptUrl;
                sfURL = response.clickToChatSettings.sfUrl;
                laURL = response.clickToChatSettings.laUrl;
                orgId = response.clickToChatSettings.orgId;
                AMPChatType = response.clickToChatSettings.ampChatSettings.chatType;
                GPAChatType = response.clickToChatSettings.gpaChatSettings.chatType;
                QNBChatType = response.clickToChatSettings.qnbChatSettings.chatType;
                initChatSettings(deploymentInfoAMP, response.clickToChatSettings.ampChatSettings);
                initChatSettings(deploymentInfoGPA, response.clickToChatSettings.gpaChatSettings);
                initChatSettings(deploymentInfoQNB, response.clickToChatSettings.qnbChatSettings);
            }
            if (callback) {
                callback(p, cb);
            }
        });
    },

    getScriptUrl: () => {
        return scriptURL;
    },

    getSfUrl: () => {
        return sfURL;
    },

    getLaUrl: () => {
        return laURL;
    },

    getOrgId: () => {
        return orgId;
    },

    getPrepopulatedPrechatFields: (portalName) => {
        if (data) {
            return data;
        }
        if (portalName === AMP) {
            return prepopulatedPrechatFieldsAMP;
        }
        if (portalName === GPA) {
            return prepopulatedPrechatFieldsGPA;
        }
        if (portalName === QB ) {
            return prepopulatedPrechatFieldsQNB;
        }
    },

    getExtraPrechatFormDetails: (portalName) => {
        if (portalName === AMP) {
            return extraPrechatFormDetailsAMP;
        }
        if (portalName === GPA) {
            return extraPrechatFormDetailsGPA;
        }
        if (portalName === QB) {
            return extraPrechatFormDetailsQNB;
        }
    },

    getExtraPrechatInfo: (portalName) => {
        if (portalName === AMP) {
            return extraPrechatInfoAMP;
        }
        if (portalName === GPA) {
            return extraPrechatInfoGPA;
        }
        if (portalName === QB) {
            return extraPrechatInfoQNB;
        }
    },

    getDeploymentInfo: (portalName) => {
        if (portalName === AMP) {
            return deploymentInfoAMP;
        }
        if (portalName === GPA) {
            return deploymentInfoGPA;
        }
        if (portalName === QB) {
            return deploymentInfoQNB;
        }
    },

    getChatType: (portalName) => {
        if (portalName === AMP) {
            return AMPChatType;
        }
        if (portalName === GPA) {
            return GPAChatType;
        }
        if (portalName === QB) {
            return QNBChatType;
        }
    },

    getAgentType: (agentType) => {
        // Requirements state to return IA in all instances except PCS
        if (agentType === 'PCS' || agentType === 'EA') {
            return 'EA';
        }
        return 'IA';
    },

    getStorageDomain: () => {
        return storageDomain;
    },

    store: (chatData) => {
        data = chatData;
    },

    retrieve: () => {
        return data;
    },

    clear: () => {
        data = false;
    }

};